import React from "react";
import useTheme from "../../../../hooks/useTheme";
import { AppPrimaryButton } from "../../../UI/CustomButtons";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppPrimaryTextfield from "../../../UI/TextInput";
import AppText from "../../../UI/Texts/AppTexts";
import UserActions from "../../../../utils/Constants/UserActions";
import { t } from "i18next";

const ContactInformationSection = ({
  formData,
  updateFormData,
  onNext,
  errors,
  loading = false,
}) => {
  const theme = useTheme();
  return (
    <AppColumn>
      <AppRow mainAxisAlignment={"space-between"} crossAxisAlignment={"start"}>
        <AppColumn mainAxisAlignment={"start"} crossAxisAlignment={"start"}>
          <AppText.HeadingBig className={'text-headline'}
            fontWeight={600}
            margins={{
              marginBottom: "0px",
              marginTop: "0px",
            }}>
            {t('registration.contact_information.title', { appName: theme.appName })}
          </AppText.HeadingBig >
          <SizedBox height={theme.spacing.elementPadding} />
          <AppText.Caption use='h2' margins={{
            marginTop: "0px",
            marginBottom: "0px",
          }} >
            {t('registration.contact_information.description')}
          </AppText.Caption >
        </AppColumn>
        <AppPrimaryButton
          userActionKey={UserActions.user_info}
          loading={loading}
          disabled={loading}
          size={"large"}
          onClick={onNext}
          style={{
            borderRadius: theme.radius.small,
          }}
        >
          {t('next')}
        </AppPrimaryButton>
      </AppRow>
      <SizedBox height={theme.spacing.contentPadding} />
      <AppPrimaryTextfield
        value={formData.email}
        keyboardTextCapitalization={'none'}
        labelText={t('your_email')}
        prefixIcon={"mail"}
        error={errors.email}
        onChange={(value) => updateFormData("email", value)}
        hintText={"anna@gmail.com"}
        onSubmit={onNext}
        maxLine={1}
        autoComplete={"email"}
      />
    </AppColumn>
  );
};

export default ContactInformationSection;